import { LOCALES } from 'i18n/locales';

export const mapPageIntl = {
    [LOCALES.ENGLISH]: {
        'mapPage.title': 'NUAR Map',
        'networkCoveragePage.title': 'NUAR Coverage List',
        'mapPage.ariaLabel': 'Map Page',
        'mapPage.message': 'NUAR',
        'mapPage.maps': 'Select the layers you\'d like to use',
        'mapPage.mapInfo.scale': 'Scale',
        'mapPage.mapInfo.coordinates': 'Coordinates',
        'mapPage.menu.info.ariaLabel': 'Map Info',
        'mapPage.menu.info.text.1': 'Begin by using the search and draw tools above to locate and draw an area of interest on the map.',
        'mapPage.menu.info.text.2': 'Controls for displaying assets will appear in this panel after an area has been drawn.',
        'mapPage.menu.info.text.3': 'For further help, please visit our help and guidance documentation or contact us.',
        'mapPage.error.forbidden': 'You do not have sufficient permissions to view this area',
        'mapPage.error.noOperationalAreas': 'Based on our records, your organisation doesn\'t operate in this area. If that\'s wrong, contact your organisation\'s administrator, or {helpLink}.',
        'mapPage.error.noOperationalAreas.helpLink': 'get help',
        'mapPage.error.areaTooLarge': 'The area you are specifying exceeds the maximum extent allowed',
        'mapPage.error.areaInvalid': 'The AOI you are drawing is not valid (e.g. due to self-intersection)',
        'mapPage.error.addObservationInsideAOI': 'You cannot add observations outside the area.',
        'mapPage.error.outsideServiceArea': 'Part of your AOI extends outside of your service area.',
        'mapPage.error.lineTooLong': 'Search area length exceeds maximum allowed extent: {extent} m.',
        'mapPage.error.lineTooWide': 'Search area width exceeds maximum allowed extent: {extent} m',
        'mapPage.location.error': 'Unable to access your location, please check your device settings',
        'mapPage.location.errorTimeOut': 'Unable to determine your location. The request timed out, please try again',
        'mapPage.pdfsDisabled': 'PDFs cannot currently be created when using the line drawing tool.'
    },
    [LOCALES.WELSH]: {
        'mapPage.title': 'Map NUAR',
        'networkCoveragePage.title': 'Rhestr cwmpas NUAR',
        'mapPage.ariaLabel': 'Tudalen Map',
        'mapPage.message': 'NUAR',
        'mapPage.maps': 'Dewiswch yr haenau yr hoffech eu defnyddio',
        'mapPage.mapInfo.scale': 'Graddfa',
        'mapPage.mapInfo.coordinates': 'Cyfesurynnau',
        'mapPage.menu.info.ariaLabel': 'Gwybodaeth Map',
        'mapPage.menu.info.text.1': 'Dechreuwch trwy ddefnyddio\'r offerynnau chwilio a thynnu llun a thynnu llun o ardal o ddiddordeb ar y map.',
        'mapPage.menu.info.text.2': 'Bydd rheolaethau ar gyfer arddangos asedau yn ymddangos yn y panel hwn ar ôl tynnu llun o ardal.',
        'mapPage.menu.info.text.3': 'Am ragor o gymorth',
        'mapPage.error.forbidden': 'Nid oes gennych ganiatâd digonol i weld yr ardal hon',
        'mapPage.error.noOperationalAreas': 'Yn ôl ein cofnodion ni, nid yw eich cwmni\'n gweithredu yn yr ardal hon. Os yw hynny\'n anghywir, cysylltwch â gweinyddwr eich sefydliad, neu {helpLink}.',
        'mapPage.error.noOperationalAreas.helpLink': 'cael help',
        'mapPage.error.areaTooLarge': 'Mae\'r ardal rydych chi\'n ei nodi yn fwy na\'r uchafswm a ganiateir',
        'mapPage.error.areaInvalid': 'Nid ywír AOI rydych yn tynnu llun ohoni\'n ddilys (e.e. oherwydd hunan-groestoriad)',
        'mapPage.error.addObservationInsideAOI': 'Ni allwch ychwanegu sylwadau y tu allan i\'r ardal.',
        'mapPage.error.outsideServiceArea': '[Part of your AOI extends outside of your service area.]',
        'mapPage.error.lineTooLong': '[Search area length exceeds maximum allowed extent: {extent} m.]',
        'mapPage.error.lineTooWide': '[Search area width exceeds maximum allowed extent: {extent} m]',
        'mapPage.location.error': 'Yn methu â gweld eich lleoliad, gwiriwch osodiadau eich dyfais',
        'mapPage.location.errorTimeOut': 'Ni allwch benderfynu ar eich lleoliad. Mae\'r cais wedi\'i amseru, ceisiwch eto',
        'mapPage.pdfsDisabled': '[PDFs cannot currently be created when using the line drawing tool.]'
    }
};
